import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";

export const NoDataContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;

export const NoDataTitle = styled.span`
    font-size: 14px;
`;

export const NoDataIcon = styled(SWReactIcons)`
    height: 90px;
    width: 194px;
    margin-bottom: 32px;
`;
